module.exports = __webpack_public_path__ + "img/75623.176d6269.svg";